import { Checkbox } from "antd";
import { useEffect, useState } from "react";
import { BiSolidCar, BiSolidTrash } from "react-icons/bi";
import { RiPagesFill } from "react-icons/ri";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner
} from "reactstrap";
import { removeItemfromArray, uniqueID } from "../../firebase/utility";
import PoDetails from "../dropdown/PoDetails";
import ImageUpload from "../imageUpload/ImageUpload";
import AddTrackingModal from "../modals/AddTrackingModal";
import DeleteItemModal from "../modals/DeleteItemModal";
import OutBoundTracking from "../Steps/OutBoundTracking";
import StockTable from "../table/StockTable";
import NotesCard from "./NotesCard";
import { getManufacturerDistributors } from "../../api/pagination";
import toast from "react-hot-toast";
import { FaBoxOpen } from "react-icons/fa";

const SaleItemCard = ({
  data,
  setLineItems,
  line_items,
  index,
  poDetails,
  orderData,
  toggleShippingModal,
  returnOrder,
  orderLabels,
  stockData,
  distributorStockLoading,
  refreshSaleOrderDetails,
}) => {
  const { all_products } = useSelector((state) => state.products);
  const [itemLabels, setItemLabels] = useState([]);
  const [product, setProduct] = useState(data);
  const [finalPurchaseOrders, setFinalPurchaseOrders] = useState([]);

  const [trackingModal, setTrackingModal] = useState(false);
  const [showLabels, setShowLabels] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [distributorsLoading, setDistributorsLoading] = useState(false);
  const [distributorsList, setDistributorsList] = useState([]);

  const toggleTrackingModal = () => setTrackingModal(!trackingModal);
  const toggleShowAndHide = () => setShowLabels(!showLabels);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleShowDistributors = () => {
    if (!product?.sku) {
      toast.error("Product SKU not found");
      return;
    }
    setDistributorsLoading(true);
    getManufacturerDistributors(product.sku, (res) => {

      setDistributorsLoading(false);
      if (res.status === 200 && res.data?.success) {
        setDistributorsList(res.data?.data?.distributors || []);
        if ((res.data?.data?.distributors || []).length === 0) {
          toast.error("No distributors found for this product");
        }
      } else {
        toast.error(res.message || "Failed to fetch distributors");
      }
    });
  };

  let parts = product?.sku?.length > 4 ? product?.sku?.slice(4) : product?.sku;
  const [formData, setFormData] = useState({
    parts: parts,
    price: product?.price ?? 0,
    vendorSku: product?.vendorSku ?? "",
    description: product?.description || product?.name || "",
    weight: product?.weight ?? 0,
    sku: product?.sku ?? "",
    quantity: product?.quantity ?? 0,
    notes: product?.notes ?? "",
    exUnitPrice: product?.exUnitPrice ?? 0,
    image: { id: product?.image?.id ?? "", src: product?.image?.src ?? "" },
    eta: product?.eta ?? "",
  });
  const [tracking, setTracking] = useState({
    trackingNumber: "",
    company: product?.company ?? "",
    quantity: product?.quantity ?? 0,
    trackingType: "",
    otherCompany: "",
  });

  const getStockQty = (parts) => {
    let result = all_products?.find((i) => {
      let part = i?.sku?.slice(4, i?.sku?.length);
      return part === parts || i?.sku === parts;
    });
    return result?.stc_quantity;
  };

  const getStockData = (skuOrPart) => {
    if (!skuOrPart || !Array.isArray(stockData) || stockData.length === 0) return [];
    
    const normalize = (val) => {
      if (!val) return "";
      return val
        .toString()
        .trim()
        .replace(/^[a-zA-Z0-9]{2,4}[-_]/i, "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();
    };

    const rawNormalize = (val) => {
      if (!val) return "";
      return val.toString().trim().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    };

    const targetNorm = rawNormalize(skuOrPart);
    const targetCore = normalize(skuOrPart);

    return stockData.filter((i) => {
      if (!i) return false;
      const candidates = [
        i?.sku,
        i?.partNumber,
        i?.itemId,
        i?.raw?.itemId,
        i?.raw?.sku,
        i?.raw?.partNumber,
        i?.raw?.vendorPartNumber,
        i?.raw?.detailedInfo?.vendorItemId,
        i?.raw?.ingramPartNumber
      ].filter(Boolean);

      return candidates.some((cand) => {
        const cNorm = rawNormalize(cand);
        const cCore = normalize(cand);
        if (targetNorm && cNorm && targetNorm === cNorm) return true;
        if (targetCore && cCore && targetCore === cCore) return true;
        if (targetCore && cNorm && (cNorm.includes(targetCore) || targetCore.includes(cNorm))) return true;
        if (targetNorm && cCore && (targetNorm.includes(cCore) || cCore.includes(targetNorm))) return true;
        return false;
      });
    });
  };

  const handleChange = (key, value) => {
    let data =
      key === "image"
        ? { ...formData, [key]: { src: value, id: uniqueID() } }
        : { ...formData, [key]: value };
    setFormData(data);
    const newData = line_items?.map((item, idx) =>
      idx === index ? { ...item, ...data } : item
    );
    setLineItems(newData);
  };

  const deleteItem = async (productID, index) => {
    const updatedLineItems = line_items.filter(
      (item) => item._id !== productID
    );
    const collection = returnOrder ? "ReturnOrders" : "Orders";
    try {
      await removeItemfromArray(
        collection,
        orderData?._id,
        "line_items",
        index
      );
      setLineItems(updatedLineItems);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    const finalPO = poDetails?.filter((i) =>
      i?.line_items?.some(
        (ii) =>
          ii?.sku?.trim()?.toUpperCase() === product?.sku?.trim()?.toUpperCase()
      )
    );
    setFinalPurchaseOrders(finalPO ?? []);
  }, [poDetails, product]);

  useEffect(() => {
    setProduct(data ?? {});
    const partsVal =
      data?.sku?.length > 4 ? data?.sku?.slice(4) : data?.sku;
    setFormData({
      parts: partsVal,
      price: data?.price ?? 0,
      vendorSku: data?.vendorSku ?? "",
      description: data?.description || data?.name || "",
      weight: data?.dimensions?.weight || data?.weight || 0,
      sku: data?.sku ?? "",
      quantity: data?.quantity ?? 0,
      notes: data?.notes ?? "",
      exUnitPrice: data?.exUnitPrice ?? 0,
      image: { id: data?.image?.id ?? "", src: data?.image?.src ?? "" },
      eta: data?.eta ?? "",
    });
  }, [data]);

  useEffect(
    () =>
      setTracking({
        trackingNumber: "",
        company: "",
        quantity: product?.quantity ?? 0,
        price: product?.exUnitPrice ?? "",
        otherCompany: "",
      }),
    [product]
  );

  useEffect(() => {
    if (orderLabels) {
      const labels = orderLabels.filter((order) =>
        order?.lineItemDetails?.some(
          (item) => item?.sku === product?.sku || item?._id === product?._id
        )
      );

      setItemLabels(labels);
    }
  }, [orderLabels, product]);

  const handleLabel = () =>
    product?.labels ? toggleShowAndHide() : toggleShippingModal();

  return (
    <>
      <DeleteItemModal
        toggle={toggleDeleteModal}
        modal={deleteModal}
        handleDelete={deleteItem}
        productId={product?._id}
        index={index}
      />
      {trackingModal && (
        <AddTrackingModal
          toggle={toggleTrackingModal}
          modal={trackingModal}
          labels={product?.labels}
          product={product}
          setProduct={setProduct}
          formData={formData}
          setFormData={setFormData}
          line_items={line_items}
          orderData={orderData}
          index={index}
          tracking={tracking}
          setTracking={setTracking}
          toggleEditTracking={toggleTrackingModal}
          refreshSaleOrderDetails={refreshSaleOrderDetails}
        />
      )}
      <Card className="shadow border border-1 mb-2 py-2 position-relative">
        <Row className="mx-0 py-3" >
          <Col md={2} xl={1}>
            <ImageUpload
              index={index}
              itemImage={formData?.image?.src}
              handleImageUpload={handleChange}
            />
            <div className="d-flex align-items-center justify-content-center">
              <div
                className="mt-2   mb-2 fw-bold fs-18  bg-success text-white  rounded-pill border border-1  d-flex justify-content-center align-items-center"
                style={{
                  height: "30px",
                  width: "30px",
                  left: "-1%",
                  top: "20%",
                }}
              >
                {index + 1}
              </div>
              <BiSolidTrash
                style={{ color: "red" }}
                size={30}
                className="my-2"
                onClick={() => {
                  toggleDeleteModal();
                  // deleteItem(product?._id, index);
                }}
              />
            </div>

          </Col>
          <Col xl={2} md={1}>
            <FormGroup className="form-group">
              <Label className=" fw-bold">Part #</Label>
              <Input
                type={"text"}
                placeholder={"Part"}
                value={formData.parts}
                onChange={(e) => handleChange("parts", e.target.value)}
                className={"border border-1 rounded-0"}
                disabled
              />
            </FormGroup>
            <FormGroup className="form-group">
              <Label className="mb-1 fw-bold">Quantity</Label>
              <Input
                type={"number"}
                placeholder={"22"}
                className={"bg-light border border-1 rounded-0"}
                value={formData.quantity}
                onChange={(e) =>
                  handleChange("quantity", parseInt(e.target.value))
                }
              />
            </FormGroup>
          </Col>
          <Col md={5}>
            <FormGroup className="form-group">
              <Label className="mb-1 fw-bold">Description</Label>
              <NotesCard
                height={"20px"}
                type={"textarea"}
                className={"bg-light border-1 rounded-0"}
                placeholder={"This is just description"}
                value={formData.description}
                handleChange={(e) =>
                  handleChange("description", e.target.value)
                }
              />
            </FormGroup>
            <FormGroup className="form-group">
              <Label className="mb-1 fw-bold">Notes</Label>
              <Input
                style={{ height: "20px" }}
                type={"textarea"}
                className={"bg-light border-1 rounded-0"}
                placeholder="Enter order Item notes"
                value={formData?.notes}
                onChange={(e) => handleChange("notes", e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup className="form-group">
              <Label className="mb-1 fw-bold">Unit Price</Label>
              <Input
                type={"text"}
                placeholder={"Unit Price"}
                className={"bg-light border border-1 rounded-0"}
                value={formData.price}
                onChange={(e) => handleChange("price", e.target.value)}
              />
            </FormGroup>
            <FormGroup className="form-group">
              <Label className="mb-2 fw-bold">Ext Price</Label>
              <Input
                type={"text"}
                placeholder={"$22"}
                className={"bg-light border border-1 rounded-0"}
                value={(formData?.price * formData?.quantity).toFixed(2)}
                readOnly={true}
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <div className="d-flex flex-column ">
              <div className="w-75">
                <FormGroup className="form-group">
                  <Label className="mb-1 fw-bold">ETA</Label>
                  <Input
                    type={"date"}
                    placeholder={"ETA"}
                    className={"bg-light border border-1 rounded-0"}
                    value={formData.eta}
                    onChange={(e) => handleChange("eta", e.target.value)}
                  />
                </FormGroup>
              </div>
              <button
                className=" border-0 w-75 bg-primary-color p-1 text-white my-1 rounded-0"
                onClick={toggleTrackingModal}
              >
                <BiSolidCar className="mx-2" />
                Tracking
              </button>
              <button
                className=" border-0 w-75 bg-primary-color p-1 text-white rounded-0"
                onClick={handleLabel}
              >
                <RiPagesFill className="mx-2" />
                Create Label
              </button>
            </div>
          </Col>
          <div className="d-flex items-center">
            <div
              className="d-flex flex-column align-items-center justify-content-center "
              style={{ width: "100px" }}
            >
              <Checkbox>
                <span className="fs-18">EPO</span>
              </Checkbox>
              <div>
                {getStockQty(parts) > 0 ? (
                  <p className="text-success fw-bold">
                    Stock({getStockQty(parts)})
                  </p>
                ) : (
                  <p className="text-danger fw-bold">Out of Stock</p>
                )}
              </div>
              <Button
                color="link"
                size="sm"
                className="text-primary p-0 text-decoration-none d-flex align-items-center"
                style={{ fontSize: "12px" }}
                onClick={handleShowDistributors}
                disabled={distributorsLoading}
              >
                {distributorsLoading ? (
                  <Spinner size="sm" color="primary" />
                ) : (
                  <>
                    <FaBoxOpen className="me-1" />
                    Distributors
                  </>
                )}
              </Button>
            </div>
            <div className="w-100">
              {finalPurchaseOrders?.length > 0 && (
                <Col md={11} className="mx-auto px-0 mb-3">
                  <PoDetails
                    data={finalPurchaseOrders}
                    lineIndex={index}
                    line_items={line_items}
                    setLineItems={setLineItems}
                    orderData={orderData}
                    product={product}
                    length={finalPurchaseOrders?.length}
                    refreshSaleOrderDetails={refreshSaleOrderDetails}
                  />
                </Col>
              )}
              {itemLabels?.length > 0 && (
                <OutBoundTracking
                  itemIndex={index}
                  labels={itemLabels ?? []}
                  product={product}
                  setProduct={setProduct}
                  orderData={orderData}
                  toggleEditTracking={toggleTrackingModal}
                  refreshSaleOrderDetails={refreshSaleOrderDetails}
                />
              )}
              {distributorStockLoading ? (
                <Col md={10} className="mx-auto mt-2">
                  <div className="d-flex align-items-center justify-content-center py-3 bg-secondary-color rounded border border-light">
                    <Spinner size="sm" color="primary" className="me-2" />
                    <span className="small text-muted fw-medium">Loading live distributor stock...</span>
                  </div>
                </Col>
              ) : getStockData(product?.sku || parts)?.length > 0 ? (
                <Col md={10} className="mx-auto">
                  <StockTable data={getStockData(product?.sku || parts) ?? []} />
                </Col>
              ) : null}

              {distributorsList?.length > 0 && (
                <Col md={10} className="mx-auto">
                  <div className="mt-2 text-start p-1">
                    <span className="fw-bold me-2 text-dark" style={{ fontSize: "14px" }}>
                      Distributors:
                    </span>
                    <div className="d-flex flex-wrap gap-1 mt-1">
                      {distributorsList.map((dist, idx) => (
                        <span
                          key={idx}
                          className="badge bg-success text-white rounded-0 fw-medium py-1 px-2"
                          style={{ fontSize: "12px" }}
                        >
                          {dist}
                        </span>
                      ))}
                    </div>
                  </div>
                </Col>
              )}
            </div>
          </div>
        </Row>
      </Card>
    </>
  );
};

export default SaleItemCard;
